(function () {
  'use strict';

  const CONFIG = {
    cookieDays: 30,
    storageKey: 'lang_popup',
    activeLangs: ['fr', 'de', 'it', 'es', 'et'],
    euDomain: 'https://eu.lunesi.co.uk',
    ukDomain: 'https://lunesi.co.uk',
    euCountries: new Set([
      'AL', 'AD', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE',
      'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'XK', 'LV',
      'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'MK', 'NO',
      'PL', 'PT', 'RO', 'SM', 'RS', 'SK', 'SI', 'SE', 'CH', 'VA'
    ]),
    countryLang: {
      FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr', CH: 'fr',
      DE: 'de', AT: 'de', LI: 'de',
      IT: 'it', SM: 'it',
      ES: 'es', AD: 'es',
      EE: 'et'
    }
  };

  const TRANSLATIONS = {
    en: {
      flag: 'https://flagcdn.com/w320/eu.png',
      title: 'We have a dedicated EU store',
      body: 'Get Euro pricing, optimised EU shipping, and local support.',
      switch: 'Go to EU store →',
      stay: 'Stay on UK store',
      note: "We'll remember your choice for 30 days"
    },
    fr: {
      flag: 'https://flagcdn.com/w320/fr.png',
      title: 'Boutique européenne disponible en français',
      body: 'Prix en euros, livraison EU optimisée — et tout en français.',
      switch: 'Continuer en français →',
      stay: 'Rester en anglais',
      note: 'Nous mémoriserons votre choix pendant 30 jours'
    },
    de: {
      flag: 'https://flagcdn.com/w320/de.png',
      title: 'Europäischer Shop auf Deutsch verfügbar',
      body: 'Euro-Preise, optimierter EU-Versand — und alles auf Deutsch.',
      switch: 'Auf Deutsch fortfahren →',
      stay: 'Auf Englisch bleiben',
      note: 'Ihre Auswahl wird 30 Tage gespeichert'
    },
    it: {
      flag: 'https://flagcdn.com/w320/it.png',
      title: 'Negozio europeo disponibile in italiano',
      body: 'Prezzi in euro, spedizioni EU ottimizzate — e tutto in italiano.',
      switch: 'Continua in italiano →',
      stay: 'Rimani in inglese',
      note: 'Ricorderemo la tua scelta per 30 giorni'
    },
    es: {
      flag: 'https://flagcdn.com/w320/es.png',
      title: 'Tienda europea disponible en español',
      body: 'Precios en euros, envío EU optimizado — y todo en español.',
      switch: 'Continuar en español →',
      stay: 'Quedarse en inglés',
      note: 'Recordaremos tu elección durante 30 días'
    },
    et: {
      flag: 'https://flagcdn.com/w320/ee.png',
      title: 'Euroopa pood saadaval eesti keeles',
      body: 'Euro hinnad, optimeeritud EU saatmine — ja kõik eesti keeles.',
      switch: 'Jätka eesti keeles →',
      stay: 'Jää inglise keelde',
      note: 'Mäletame teie valikut 30 päeva'
    },
    main: {
      flag: 'https://flagcdn.com/w320/gb.png',
      title: 'Visit our main store',
      body: 'Our main store offers worldwide shipping, GBP pricing, and our full range.',
      switch: 'Go to lunesi.co.uk →',
      stay: 'Stay on EU store',
      note: "We'll remember your choice for 30 days"
    }
  };

  let elements = null;

  function getElements() {
    if (elements) return elements;
    elements = {
      overlay:   document.querySelector('.lang-popup__overlay'),
      flagImg:   document.querySelector('.lang-popup__flag-img'),
      title:     document.querySelector('.lang-popup__title'),
      body:      document.querySelector('.lang-popup__body'),
      btnSwitch: document.querySelector('.lang-popup__btn--switch'),
      btnStay:   document.querySelector('.lang-popup__btn--stay'),
      note:      document.querySelector('.lang-popup__note'),
      close:     document.querySelector('.lang-popup__close'),
    };
    return elements;
  }

  function getStored() {
    try {
      const raw = localStorage.getItem(CONFIG.storageKey);
      if (!raw) return null;
      const stored = JSON.parse(raw);
      if (Date.now() > stored.exp) { localStorage.removeItem(CONFIG.storageKey); return null; }
      return stored.v;
    } catch (error) { return null; }
  }

  function setStored(value) {
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify({
        v: value, exp: Date.now() + CONFIG.cookieDays * 864e5
      }));
    } catch (error) {}
  }

  function buildLangUrl(targetLang) {
    const path = window.location.pathname;
    const cleanPath = path.replace(/^\/[a-z]{2}(\/|$)/, '/');
    const skipPaths = ['/cart', '/checkout', '/account'];
    if (skipPaths.some(p => cleanPath.startsWith(p))) {
      return targetLang === 'en' ? CONFIG.euDomain : CONFIG.euDomain + '/' + targetLang;
    }
    const newPath = targetLang === 'en'
      ? (cleanPath === '/' ? '' : cleanPath)
      : '/' + targetLang + (cleanPath === '/' ? '' : cleanPath);
    return CONFIG.euDomain + newPath + window.location.search;
  }

  function buildMainUrl() {
    const path = window.location.pathname;
    const cleanPath = path.replace(/^\/[a-z]{2}(\/|$)/, '/');
    const skipPaths = ['/cart', '/checkout', '/account'];
    if (skipPaths.some(p => cleanPath.startsWith(p))) return CONFIG.ukDomain;
    return CONFIG.ukDomain + (cleanPath === '/' ? '' : cleanPath) + window.location.search;
  }

  function resolveEUTarget(countryCode) {
    if (!CONFIG.euCountries.has(countryCode)) return null;
    const mapped = CONFIG.countryLang[countryCode] || '';
    if (mapped && CONFIG.activeLangs.indexOf(mapped) !== -1) return mapped;
    const browserLang = (navigator.language || '').toLowerCase().split('-')[0];
    if (browserLang && CONFIG.activeLangs.indexOf(browserLang) !== -1) return browserLang;
    return 'en';
  }

  function hide() {
    const { overlay } = getElements();
    overlay.classList.remove('lang-popup__overlay--visible');
    setTimeout(() => { overlay.style.display = 'none'; }, 220);
  }

  function bindEvents(translationKey) {
    const { btnSwitch, btnStay, close } = getElements();

    btnSwitch.addEventListener('click', () => setStored('switched:' + translationKey));

    btnStay.addEventListener('click', () => {
      setStored('stayed');
      hide();
    });

    close.addEventListener('click', () => {
      setStored('dismissed');
      hide();
    });

    document.addEventListener('keydown', function onEsc(event) {
      if (event.key === 'Escape') {
        setStored('dismissed');
        hide();
        document.removeEventListener('keydown', onEsc);
      }
    });
  }

  function show(translationKey, switchHref) {
    const translation = TRANSLATIONS[translationKey];
    const { overlay, flagImg, title, body, btnSwitch, btnStay, note } = getElements();

    flagImg.src = translation.flag;
    title.textContent = translation.title;
    body.textContent = translation.body;
    btnSwitch.textContent = translation.switch;
    btnSwitch.href = switchHref;
    btnStay.textContent = translation.stay;
    note.textContent = translation.note;

    overlay.style.display = 'flex';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add('lang-popup__overlay--visible'));
    });
    setTimeout(() => btnSwitch.focus(), 250);
  }

  function init() {
    if (getStored()) return;

    const isEUSite = window.location.hostname === 'eu.lunesi.co.uk';

    fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
      credentials: 'same-origin'
    })
      .then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(data => {
        const countryCode = (((data.detected_values || {}).country || {}).handle || '').toUpperCase();

        if (isEUSite) {
          // EU site: show popup for any non-EU visitor
          if (CONFIG.euCountries.has(countryCode)) return;
          bindEvents('main');
          show('main', buildMainUrl());
        } else {
          // Main site: show popup for EU visitors
          const targetLang = resolveEUTarget(countryCode);
          if (!targetLang) return;
          bindEvents(targetLang);
          show(targetLang, buildLangUrl(targetLang));
        }
      })
      .catch(error => console.warn('[lang-popup]', error.message));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 600));
  } else {
    setTimeout(init, 600);
  }
})();
